/* Etiquetas y filtros, sin pantalla · CATÁLOGO VIVO F4.
   Funciones puras: el color de cada etiqueta, el estado de los chips y lo
   que se recuerda del filtro en este teléfono. */

// La paleta de 12 (migración 1193), con contraste medido: texto 900 sobre
// fondo 100 pasa AA en claro, y el nombre va SIEMPRE junto al color (F4.4).
export const PALETA = {
  gris: 'bg-gray-100 text-gray-900 border-gray-300',
  rojo: 'bg-red-100 text-red-900 border-red-300',
  naranja: 'bg-orange-100 text-orange-900 border-orange-300',
  ambar: 'bg-amber-100 text-amber-900 border-amber-300',
  verde: 'bg-green-100 text-green-900 border-green-300',
  esmeralda: 'bg-emerald-100 text-emerald-900 border-emerald-300',
  turquesa: 'bg-teal-100 text-teal-900 border-teal-300',
  azul: 'bg-blue-100 text-blue-900 border-blue-300',
  indigo: 'bg-indigo-100 text-indigo-900 border-indigo-300',
  violeta: 'bg-violet-100 text-violet-900 border-violet-300',
  rosa: 'bg-pink-100 text-pink-900 border-pink-300',
  cafe: 'bg-stone-200 text-stone-900 border-stone-400',
};
export const NOMBRE_COLOR = {
  gris: 'Gris', rojo: 'Rojo', naranja: 'Naranja', ambar: 'Ámbar', verde: 'Verde',
  esmeralda: 'Esmeralda', turquesa: 'Turquesa', azul: 'Azul', indigo: 'Índigo',
  violeta: 'Violeta', rosa: 'Rosa', cafe: 'Café',
};
export const claseDeColor = (color) => PALETA[color] || PALETA.gris;

// Tocar un chip: si estaba fuera, entra; si estaba dentro, sale. Sostener:
// si no estaba excluido, se excluye; si lo estaba, vuelve a neutro (F4.2).
export function tocar(filtro, id) {
  const dentro = new Set(filtro.etiquetas || []);
  const fuera = new Set(filtro.excluir_etiquetas || []);
  if (dentro.has(id)) dentro.delete(id); else { dentro.add(id); fuera.delete(id); }
  return { ...filtro, etiquetas: [...dentro], excluir_etiquetas: [...fuera] };
}
export function sostener(filtro, id) {
  const dentro = new Set(filtro.etiquetas || []);
  const fuera = new Set(filtro.excluir_etiquetas || []);
  if (fuera.has(id)) fuera.delete(id); else { fuera.add(id); dentro.delete(id); }
  return { ...filtro, etiquetas: [...dentro], excluir_etiquetas: [...fuera] };
}
export function estadoChip(filtro, id) {
  if ((filtro.excluir_etiquetas || []).includes(id)) return 'fuera';
  if ((filtro.etiquetas || []).includes(id)) return 'dentro';
  return 'neutro';
}

export const FILTRO_VACIO = { categorias: [], etiquetas: [], excluir_etiquetas: [], ubicacion_raiz: null, atributos: [], texto: '', bajo_minimo: false };

export function hayFiltro(f) {
  return Boolean((f.categorias || []).length || (f.etiquetas || []).length || (f.excluir_etiquetas || []).length
    || f.ubicacion_raiz || (f.atributos || []).length || (f.texto || '').trim() || f.bajo_minimo);
}

// Lo que se recuerda por persona y dispositivo (F4.2). localStorage puede no
// estar (ventana privada): se lee y se escribe dentro de try/catch y la
// pantalla funciona igual sin él.
const CLAVE = (idUsuario) => `tego.catalogoVivo.filtro.${idUsuario || 'anonimo'}`;
export function recordar(idUsuario, filtro) {
  try { localStorage.setItem(CLAVE(idUsuario), JSON.stringify(filtro)); } catch { /* sin almacén: se sigue */ }
}
export function recordado(idUsuario) {
  try {
    const t = localStorage.getItem(CLAVE(idUsuario));
    const f = t ? JSON.parse(t) : null;
    return f && typeof f === 'object' ? { ...FILTRO_VACIO, ...f } : { ...FILTRO_VACIO };
  } catch {
    return { ...FILTRO_VACIO };
  }
}
